import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  DebugElement,
} from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../shared/providers/common.service';
import { AuditTrailLogListModel } from '../shared/models/AuditTrailLogListModel';
import { AuditTrailDetailModel } from '../shared/models/AuditTrailDetailModel';
//import {
//  CompleterService,
//  CompleterData,
//  //Ng2CompleterModule,
//} from 'ng2-completer';
import { LoaderService } from '../shared/providers/loader.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { IUserRole } from '../shared/models/UserRoleOutputModel';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ValidationService } from '../shared/providers/validation.service';
import { IUser } from '../shared/models/user';
import {
  AuditLogCategoryModel,
  CategoryList,
  SubcategoryList,
  SearchCategory,
} from '../shared/models/AuditLogCategoryModel';
import { ReplaySubject, Observable } from 'rxjs';
import { TagInputModule } from 'ngx-chips';
import { ToastService } from '../shared/providers/toast.service';
import {
  IPropertyAuditLogFilter,
  IPropertyData,
  IPropertyListOutputModel,
} from '../shared/models/PropertyData';
enum AccessFrom {
  NotFromComponent = 0,
  UserDetails = 1,
}

interface IDropDownData {
  value: number;
  display: string;
  TypeId: number;
}

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.css'],
})
export class AuditTrailComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  @Input() objectId: number;
  @Input() objectTypeId: number;
  @Input() getPropertyId: number;
  @Input() propertyView: boolean;
  @Input() User = {} as IUser;
  @Input() exchangeOwner: number = 0;
  @Input() isExchangeAudit: boolean = false;
  @Input() propertyModuleTypeID: number;
  @Input() exchangeId: number = 0;
  @Input() IsDisplayUser: number = 0;
  @Input() previousRoute: string = '';
  @Input() propertyIdList: number[] = [];
  @Input() isPrincipal: boolean = false;

  auditTrailLogListModel: AuditTrailLogListModel[];
  auditTrailDetailModel: AuditTrailDetailModel[];
  auditLogCategoryModel: AuditLogCategoryModel[];
  auditLogCategoryModelDetails: AuditLogCategoryModel[];
  categoryList: CategoryList[];
  categoryListNew: CategoryList;
  subcategoryLst: SubcategoryList;
  searchCategory: SearchCategory;
  searchCategoryLst: SearchCategory[] = [];
  exchangeCategoryList: CategoryList[];
  exchangeUserCategoryList: CategoryList[];
  exchangeCategoryListNew: CategoryList;
  exchangeSubcategoryLst: SubcategoryList;
  users: any[];
  propertysearchfilter: IPropertyAuditLogFilter;
  tenantlst: IDropDownData[];
  userlst: IDropDownData[];
  roleLst: IDropDownData[];
  propertyTypeLst: IDropDownData[];
  subCategoryLst: IDropDownData[];
  tenants: any[];
  properties: any[];
  subCategory: any[];
  propertyType: any[];
  dtOptions = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  auditTrailList: any[];
  exportList: any;
  modalRef: BsModalRef;
  //propertyDataService: CompleterData;
  //userDataService: CompleterData;
  dateFromRange: Date;
  dateToRange: Date;
  userId: number = 0;
  propertyId: number = 0;
  userRoleId: number = 0;
  actionTypeId: number = 0;
  placeOfferPropertyId: number = 0;
  propertyName: string;
  userName: string;
  actionList: ILookUp[];
  userRoleList: IUserRole[];
  propertyids: number[] = [];
  tenantids: number[] = [];
  userids: number[] = [];
  roleids: number[] = [];
  propertyTypeIds: number[] = [];
  subCategoryIds: number[] = [];
  filteredPropertyLst: IPropertyListOutputModel[] = [];
  propertyLstNew: IPropertyData[] = [];
  showActionType: boolean = false;
  prevPage: string = '';
  prevPageRouteLink: string = '';
  previousPageRouteName: string = '';
  selectedText: string = '';
  selectedSubcategoryCount: number = 0;
  isExport: boolean = false;
  user: any;

  constructor(
    private _commonService: CommonService,
    protected loaderService: LoaderService,
    private _toastService: ToastService,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private router: Router,
    private http: HttpClient,
   /* private completerService: CompleterService,*/
    private _userManagerService: UserManagerService,
    private authService: AuthenticationService,
    private propertyManagementService: PropertyManagementService,
    public Validation: ValidationService
  ) {}
  accessFrom = AccessFrom;
  currentAccess = AccessFrom.NotFromComponent;
  propertyAddedByInfo: any;
  isAdmin = false;
  isBroker = false;

  ngOnInit() {

    ////if (!(this.authService.IsUserRole(this.authService.UserRole.Admin))) {
    ////  this.router.navigate(['/unauthorized']);
    ////}

    if (this.IsDisplayUser == 1 && this.User != null && this.User.Id > 0) {
      this.userids.push(this.User.Id);
      this.previousPageRouteName = this.previousRoute;
    } else {
      this.previousPageRouteName = 'Activity Log';
    }

    if (this.propertyIdList != undefined && this.propertyIdList.length > 0) {
      this.propertyids = this.propertyIdList;
    }

    this.user = this.authService.user;
    this.selectedText = ' Select Action ';
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
      }
    });

    this.isAdmin = (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin));
    this.isBroker = this.authService.IsUserRole(
      this.authService.UserRole.Broker
    );

    this.gettenantdetails();
    this.bindProperties();
    this.bindusers();
    //// Loads the action list from audit trail
    if (this.getPropertyId != undefined && this.getPropertyId != 0) {
      this.propertyId = this.getPropertyId;
      this.placeOfferPropertyId = this.getPropertyId;

      this.propertyManagementService
        .GetPropertyAddedByInfo(this.getPropertyId)
        .subscribe((res) => {
          this.propertyAddedByInfo = res;
        });
    }
    this.bindPropertyTypes();

    //// Loads the user role list from audit trail
    this._commonService.getUserRolesList().subscribe((response) => {
      this.userRoleList = response
        .map((o) => {
          return { id: o.Id, name: o.Description };
        })
        .filter(
          (x) => x.id != 5 && x.id != 6 && x.id != 7 && x.id != 8 && x.id != 12
        );
      for (var i = 0; i < this.userRoleList.length; i++) {
        if (this.userRoleList[i].id == 3) {
          this.userRoleList[i].name = this.authService.getUserRoleDescription(
            this.authService.UserRole.Broker
          );
        }
        if (this.userRoleList[i].id == 4) {
          this.userRoleList[i].name = this.authService.getUserRoleDescription(
            this.authService.UserRole.Principal1031
          );
        }
      }
    });

    if (this.User != null && this.User.Id > 0) {
      this.userName = this.User.UserName;
      this.userId = this.exchangeOwner == 0 ? this.User.Id : this.exchangeOwner;
      this.userRoleId = this.exchangeOwner == 0 ? this.User.RoleId : 4;
      this.currentAccess = AccessFrom.UserDetails;
    }
    this.loadData();
    this.showCategories();
  }
  onRoleChange() {
    if (this.userRoleId == this.authService.UserRole.DataEntryStaff) {
      this.actionList = this.actionList.filter((x) => x.id === 2601);
    } else {
      this.loadActions();
    }
  }

  loadActions() {
    this._commonService.getLookupsByTypeId(33).subscribe((response) => {
      this.actionList = response.map((o) => {
        return {
          id: o.Id,
          description: o.Description,
        };
      });
      if (this.userRoleId == this.authService.UserRole.DataEntryStaff) {
        this.actionList = this.actionList.filter((x) => x.id === 2601);
      }
    });
    if (this.exchangeId > 0) {
      if (this.isExchangeAudit) {
        this.exchangeCategoryList = [];

        this.categoryList.forEach((item) => {
          if (item.CategoryId == 320) {
            this.exchangeCategoryList.push(item);
          }
          if (item.CategoryId == 323) {
            this.exchangeCategoryList.push(item);
          }
          if (item.CategoryId == 302) {
            item.SubCategory = item.SubCategory.filter(
              (x) => x.SubCategoryId == 2631
            );
            this.exchangeCategoryList.push(item);
          }
          if (item.CategoryId == 303) {
            item.SubCategory = item.SubCategory.filter(
              (x) => x.SubCategoryId == 2610
            );
            this.exchangeCategoryList.push(item);
          }
        });
      } else {
        // Details to be shown in the audit log for users in exchange page
        this.exchangeUserCategoryList = [];
        this.categoryList.forEach((item) => {
          if (item.CategoryId == 303) {
            item.SubCategory = item.SubCategory.filter(
              (x) => x.SubCategoryId == 2610
            );
            this.exchangeUserCategoryList.push(item);
          }
          if (item.CategoryId == 302) {
            item.SubCategory = item.SubCategory.filter(
              (x) => x.SubCategoryId == 2603
            );
            this.exchangeUserCategoryList.push(item);
          }
        });
      }
    }
  }

  loadData() {
    const that = this;
    that.isExport = false;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      pageLength: 50,
      order: [[0, 'desc']],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.loaderService.display(true);
        const filter = {
          UserId: this.userId,
          PropertyId: this.propertyId,
          DateFrom: this.dateFromRange,
          DateTo: this.dateToRange,
          UserRoleId: this.userRoleId,
          LookupId: this.actionTypeId,
          PlaceOfferPropertyId: this.placeOfferPropertyId,
          PropertyModuleTypeID: this.propertyModuleTypeID,
          ExchangeId: this.exchangeId,
          SearchList: this.searchCategoryLst,
          isExchangeAudit: this.isExchangeAudit,
          TenantLst: this.tenantids,
          PropertyLst: this.propertyids,
          UserLst: this.userids,
          RoleLst: this.roleids,
          IsExport: this.isExport,
          LoggedInUserId: this.user.Id,
          PropertyTypes: this.propertyTypeIds,
          SubCategories: this.subCategoryIds,
          IsPortfolio: this.isPrincipal,
        };

        dataTablesParameters.Extra_param = filter;

        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/common/getAuditTrailList',
            dataTablesParameters,
            httpHeader
          )
          .subscribe((resp) => {
            that.auditTrailList = resp.data ? resp.data : [];
            that.auditTrailList.forEach((item) => {
              if (item.ActionId == 2615) {
                item.Merge = this.setMergedPropertyArray(item.MergeInfo);
              }
            });
            if (resp) {
              $('.dataTables_wrapper table thead').hide();
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: [],
              });
              if (resp.data.length === 0) {
                $('.dataTables_paginate.paging_full_numbers').hide();
              } else {
                $('.dataTables_paginate.paging_full_numbers').show();
              }
              $('.paginate_button.first,.paginate_button.last').hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
              $('.dataTables_paginate.paging_full_numbers').hide();
            }

            this.loaderService.display(false);
          });
      },
      columns: [
        //{ data: 'AnalysisId' },
        { data: 'CreatedOn' },
        { data: 'ShortDescription' },
        { data: 'ObjectName' },
      ],
    };
  }

  loadAuditTrailLogData() {
    this._commonService
      .GetAuditTrailLogList(this.objectId, this.objectTypeId)
      .subscribe((response) => {
        if (response != null) {
          this.auditTrailLogListModel = response;
          // this.auditTrailLogListModel[0].IsActive = true;
          this.loadAuditTrailDetailData(
            this.auditTrailLogListModel[0].AuditTrailLogId
          );
        }
      });
  }

  loadAuditTrailDetailData(Id) {
    this._commonService.GetAuditTrailDetailList(Id).subscribe((response) => {
      if (response != null) {
        this.auditTrailDetailModel = response;
      }
    });
  }

  convertUTCDateToLocalDate(InquiryDate: Date) {
    var newDate = new Date(InquiryDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - offset * 60 * 1000 * 60);
    return offsetTime;
  }
  AuditId: number;
  openModalForAuditTrailDetail(template: TemplateRef<any>, classes: any, id) {
    this.AuditId = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onPropertySelect($event) {
    if ($event.originalObject) {
      this.propertyId = $event.originalObject.Id;
    }
  }

  onUserSelect($event) {
    if ($event.originalObject) {
      this.userId = $event.originalObject.Id;
      this._commonService.getUserRole(this.userId).subscribe((response) => {
        var roleId = response;
        this.userRoleId = parseInt(roleId.toString());
      });
    }
  }

  resetSearch() {
    this.tenants = [];
    this.tenantids = [];
    this.properties = [];
    if (
      this.isPrincipal == undefined ||
      this.isPrincipal == null ||
      !this.isPrincipal
    ) {
      this.propertyids = [];
    }
    if (this.userids == null || this.userids == undefined) {
      this.userids = [];
    }
    /*this.propertyids = [];*/
    this.propertyType = [];
    this.subCategory = [];
    this.propertyTypeIds = [];
    this.subCategoryIds = [];
    this.users = [];
    /*this.userids = []*/
    this.isExport = false;
    this.userId = 0;
    if (this.getPropertyId != undefined && this.getPropertyId != 0) {
      this.propertyId = this.getPropertyId;
    } else {
      this.propertyId = 0;
    }
    this.actionTypeId = 0;
    this.userRoleId = 0;
    this.dateFromRange = null;
    this.propertyName = null;
    this.userName = null;
    this.dateToRange = null;
    this.loadActions();
    if (this.User != null && this.User.Id > 0) {
      this.userName = this.User.UserName;
      this.userId = this.exchangeOwner == 0 ? this.User.Id : this.exchangeOwner;
      this.userRoleId = this.exchangeOwner == 0 ? this.User.RoleId : 4;
      this.currentAccess = AccessFrom.UserDetails;
    }
    this.searchCategoryLst = [];
    this.selectedSubcategoryCount = 0;
    this.selectedText = ' Select Action ';
    $('input:checkbox').prop('checked', false);
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  search() {
    this.isExport = false;
    if (this.userName == '') {
      this.userName = null;
      this.userId = 0;
    }
    if (this.propertyName == '') {
      this.propertyName = null;
      this.propertyId = 0;
    }
    this.dtElement.dtInstance.then((x) => x.draw());
  }

  onBreadCrumbClick() {
    this.router.navigateByUrl(this.prevPageRouteLink);
  }

  setMergedPropertyArray(val: string) {
    let pList = [];
    if (val) {
      let value = ([] = val.split(','));
      value.forEach((item) => {
        if (item) {
          let prop = item.split('|');
          const p = {
            PId: prop[0],
            PGuid: prop[1],
          };
          pList.push(p);
        }
      });
    }
    return pList;
  }

  openProperty(PGuid) {
    this.Validation.openLinkInNewTab('/viewproperty/' + PGuid);
  }

  selectSubCategory(subCat) {
    if (subCat.SelectedSubCategory) {
      this.searchCategory = new SearchCategory();
      this.searchCategory.CategoryId = subCat.CategoryId;
      this.searchCategory.SubCategoryId = subCat.SubCategoryId;
      this.searchCategoryLst.push(this.searchCategory);
    } else {
      var index = this.searchCategoryLst.findIndex(
        (x) =>
          x.CategoryId == subCat.CategoryId &&
          x.SubCategoryId == subCat.SubCategoryId
      );
      this.searchCategoryLst.splice(index, 1);
    }
  }

  showCategories() {
    this.categoryList = [];
    this._commonService
      .GetCategories(this.isPrincipal)
      .subscribe((response) => {
        this.auditLogCategoryModel = response;
        this.auditLogCategoryModel.forEach((item) => {
          this.categoryListNew = new CategoryList();
          this.auditLogCategoryModelDetails = [];
          var index = this.categoryList.findIndex(
            (p) => p.CategoryId == item.CategoryId
          );
          if (index == -1) {
            this.categoryListNew.CategoryId = item.CategoryId;
            this.categoryListNew.Category = item.Category;
            this.categoryListNew.SubCategory = [];
            this.categoryList.push(this.categoryListNew);
            this.auditLogCategoryModel.forEach((items) => {
              if (items.CategoryId == item.CategoryId) {
                this.subcategoryLst = new SubcategoryList();
                this.subcategoryLst.CategoryId = items.CategoryId;
                this.subcategoryLst.SubCategoryId = items.SubCategoryId;
                this.subcategoryLst.SubCategory = items.SubCategory;
                this.subcategoryLst.SelectedSubCategory = false;
                this.categoryListNew.SubCategory.push(this.subcategoryLst);
              }
            });
          }
        });
        this.loadActions();
      });
  }

  changeFilterLabel(select) {
    if (select.SelectedSubCategory) {
      this.selectedSubcategoryCount = this.selectedSubcategoryCount + 1;
    } else {
      this.selectedSubcategoryCount = this.selectedSubcategoryCount - 1;
    }

    if (this.selectedSubcategoryCount > 1) {
      this.selectedText = this.selectedSubcategoryCount + ' Items selected';
    } else if (this.selectedSubcategoryCount == 1) {
      this.selectedText = this.selectedSubcategoryCount + ' Item selected';
    } else if (this.selectedSubcategoryCount == 0) {
      this.selectedText = ' Select Action ';
    }
  }

  gettenantdetails() {
    this._commonService.GetTenantList().subscribe((response) => {
      this.tenantlst = response.map((o) => {
        return {
          value: o.Id,
          display: o.TenantName,
          TypeId: 0,
        };
      });
    });
  }

  bindusers() {
    this._commonService.GetUsersLst().subscribe((response) => {
      this.userlst = response.map((o) => {
        return {
          value: o.Id,
          display: o.Name,
          TypeId: 0,
        };
      });
    });
  }

  binduserssearch(event) {
    this._commonService.GetUserSearch(event).subscribe((response) => {
      this.userlst = response.map((o) => {
        return {
          value: o.Id,
          display: o.Name,
          TypeId: 0,
        };
      });
    });
  }

  bindProperties() {
    this._commonService.GetProperties().subscribe((response) => {
      this.propertyLstNew = response.map((o) => {
        return {
          value: o.Id,
          display: o.PropertyName,
          tenantid: o.TenantId,
        };
      });
    });
  }

  onAdd(event, filtername) {
    if (filtername == 'Tenant') {
      this.tenantids.push(event.value);
      this.propertySearch(event.description);
    } else if (filtername == 'Property') {
      this.propertyids.push(event.value);
    } else if (filtername == 'User') {
      this.userids.push(event.value);
    } else if (filtername == 'Role') {
      this.roleids.push(event.value);
    } else if (filtername == 'Property Type') {
      this.propertyTypeIds.push(event.value);
      this.bindSubCategories(this.propertyTypeIds);
      this.propertySearch(event.description);
    } else if (filtername == 'Subcategory') {
      this.subCategoryIds.push(event.value);
      this.propertySearch(event.description);
    }
  }

  onRemove(event, filterName) {
    if (filterName == 'Tenant') {
      const index = this.tenantids.indexOf(event.value);
      if (index > -1) {
        this.tenantids.splice(index, 1);
      }
    } else if (filterName == 'Property') {
      const index = this.propertyids.indexOf(event.value);
      if (index > -1) {
        this.propertyids.splice(index, 1);
      }
    } else if (filterName == 'User') {
      const index = this.userids.indexOf(event.value);
      if (index > -1) {
        this.userids.splice(index, 1);
      }
    } else if (filterName == 'Role') {
      const index = this.roleids.indexOf(event.value);
      if (index > -1) {
        this.roleids.splice(index, 1);
      }
    } else if (filterName == 'Property Type') {
      const index = this.propertyTypeIds.indexOf(event.value);
      if (index > -1) {
        this.propertyTypeIds.splice(index, 1);
      }
      if (this.subCategoryLst.length > 0) {
        this.subCategoryLst = this.subCategoryLst.filter(
          (x) => x.TypeId != event.value
        );
      }
    } else if (filterName == 'Subcategory') {
      const index = this.subCategoryIds.indexOf(event.value);
      if (index > -1) {
        this.subCategoryIds.splice(index, 1);
      }
    }
    this.propertySearch(event.description);
  }

  exportToExcell() {
    this.loaderService.display(true);
    this.isExport = true;
    const filter = {
      UserId: this.userId,
      PropertyId: this.propertyId,
      DateFrom: this.dateFromRange,
      DateTo: this.dateToRange,
      UserRoleId: this.userRoleId,
      LookupId: this.actionTypeId,
      PlaceOfferPropertyId: this.placeOfferPropertyId,
      PropertyModuleTypeID: this.propertyModuleTypeID,
      ExchangeId: this.exchangeId,
      SearchList: this.searchCategoryLst,
      isExchangeAudit: this.isExchangeAudit,
      TenantLst: this.tenantids,
      PropertyLst: this.propertyids,
      UserLst: this.userids,
      RoleLst: this.roleids,
      IsExport: this.isExport,
      LoggedInUserId: this.user.Id,
      PropertyTypes: this.propertyTypeIds,
      SubCategories: this.subCategoryIds,
    };
    const dataTablesParameters = {
      Extra_param: filter,
    };
    const httpHeader = this.Validation.GetAuthHeader();
    this.http
      .post<string>(
        this.BASE_URL + '/common/getAuditTrailList',
        dataTablesParameters,
        httpHeader
      )
      .subscribe((resp) => {
        console.log(resp);
        this.exportList = resp;
        if (this.exportList.Result == 'BackGroundTask') {
          this._toastService.addToast({
            title: 'Success',
            msg: 'Exported Audit List has been mailed to your Email address',
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'success',
          });
          this.loaderService.display(false);
        } else {
          let filenameWithExtension: string = this.exportList.Result.toString();
          let filenameWithoutExtension = filenameWithExtension
            .toString()
            .split('.')[0];
          this.Validation.downloadExcelFile(
            '/upload/excelfile/' + filenameWithoutExtension,
            'Audit List.xlsx'
          );
          this.loaderService.display(false);
        }
      });

    this.isExport = true;
  }

  onexportclick() {
    this.exportToExcell();
  }

  propertySearch(event) {
    const filter = {
      TenantLst: this.tenantids,
      PropertyTypes: this.propertyTypeIds,
      SubCategories: this.subCategoryIds,
      SearchText: event,
    };
    this.propertysearchfilter = filter;

    this._commonService
      .GetPropertiesBySearch(this.propertysearchfilter)
      .subscribe((response) => {
        this.propertyLstNew = response.map((o) => {
          return {
            value: o.Id,
            display: o.PropertyName,
          };
        });
      });
  }

  tenantSearch(event) {
    this._commonService.GetTeanantBySearch(event).subscribe((response) => {
      this.tenantlst = response.map((o) => {
        return {
          value: o.Id,
          display: o.TenantName,
          TypeId: 0,
        };
      });
    });
  }

  bindPropertyTypes() {
    this._commonService.GetPropertyTypes().subscribe((response) => {
      this.propertyTypeLst = response.map((o) => {
        return {
          value: o.Id,
          display: o.Type,
          TypeId: 0,
        };
      });
    });
  }

  bindSubCategories(propertyTypeid: any) {
    this._commonService
      .getSubcategoryList(propertyTypeid)
      .subscribe((response) => {
        this.subCategoryLst = response.map((o) => {
          return {
            value: o['Id'],
            display: o['Name'],
            TypeId: o['MasterId'],
          };
        });
      });
  }
}
